import { OnInit, Component, OnDestroy, ElementRef, ViewChildren, HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Wrapper } from 'src/app/components/wrapper.component';
import { style, state, animate, transition, trigger } from '@angular/animations';
// import * as Hammer from 'hammerjs';
import * as swipedEvents from 'swiped-events';
import { EventPermissionsService, PAGE_NAME } from 'src/app/services/event.permissions.service';
import { LabelMaps, makeEmptyLabelMaps, JoiEvent, eventsFeature, eventsActions } from 'src/app/store/events.era';
import { getPropSizes,  loadLocal, saveLocal } from '../../helpers/helpers';
// import { ManageSessionComponent } from '../manage/manage-session.component';
// import { ManageProgramComponent } from '../manage/manage-program.component';
// import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { NewProgramDialogComponent } from 'src/app/components/wizards/newProgram.dialog.component';
import { Sponsor } from 'globals/store/sponsors.data';
import { InputDialogReturnData } from 'src/app/components/wizards/input.dialog.component';
import { DropdownOption, inheritableFields, ManageProgramData, ManageSessionData, Program, Session } from 'globals/store/programs.data';
// import { getProgramTimezoneIds, missingOutdatedVenueFormatVenues, programOptionsReselector, programsArray } from 'globals/store/reselectors/programs.reselector';
import { sleepForMS } from './../../helpers/helpers';
import { createBarChart } from '../../components/nav-bar/event-bar-chart';
import { TextToggleData } from 'globals/store/app.data';
import { NewDay, programsActions } from 'src/app/store/programs.era';
import { CommonModule } from '@angular/common';
import { ProgramService } from 'src/app/services/program.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { ZoomWrapper } from "src/app/components/wrappers/zoom-wrapper.component";
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { copyObjectWithProps, jsonCopyObject } from 'globals/helpers/helpers';
import { TopMenuComponent } from './top.menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProgramLaneComponent } from './program-lane.component';
import { trackByProgram } from 'src/app/services/helpers/angular.helper';
import { MenuHoverButtonComponent } from 'src/app/components/buttons/menu-hover-button.component';
import { getProgramTimezoneIds, missingOutdatedVenueFormatVenues, programOptionsReselector, programsArray } from 'src/app/store/reselectors/programs.reselector';
import { permissionsFeature } from 'src/app/store/permissions.era';
import { MatButtonModule } from '@angular/material/button';
import { CdkDragDrop, CdkDropList, moveItemInArray, CdkDragHandle, CdkDrag, transferArrayItem, CdkDropListGroup } from "@angular/cdk/drag-drop";
import { CheckDialogComponent, OnlyChecksDialogData } from 'src/app/components/wizards/checks.dialog.component';
import { ManageProgramComponent } from '../manage/manage-program.component';
import { createSelector } from '@ngrx/store';
import { workforceFeature, workforceStateSelector } from 'src/app/store/workforce.era';
import { lastValueFrom, take } from 'rxjs';
import { ManageSessionComponent } from '../manage/manage-session.component';
import { sponsorsFeature } from 'src/app/store/sponsors.era';
import { performersFeature } from 'src/app/store/performers.era';
import { manageSessionPermissionReselector, ManageSessionStates, manageSessionStates } from 'src/app/store/reselectors/sessions.reselector';

@Component({
    selector: 'program-page',
    templateUrl: 'program.page.html',
    animations: [
        trigger('drop', [
            state('collapse', style({ height: '0', padding: 0 })),
            transition('expanded <=> collapse', animate("{{ timing }}"), { params: { timing: "0ms" } })
        ])
    ],
    styleUrls: ['../../page.scss', 'program.page.scss'],// , '../../components/buttons/toggle-tab.styl'
    styles: [`
    .toggle-holder { display: flex; gap: 4px; min-height: 32px; white-space: nowrap; align-items: center; font-size: 12px; font-weight: bold; margin-left: 10px; background: var(--disabled); border-radius: 15px; padding: 3px 3px 3px 9px; cursor: pointer; color: white; }
    .toggle-holder.selected { background: var(--primary) !important; }  
    .toggle-holder mat-slide-toggle { transform: scale(0.7);height: 20px;
    position: relative;
    top: -4px;
    width: 46px;}
  `],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MenuHoverButtonComponent, ProgramLaneComponent, MatSlideToggleModule, MatProgressBarModule, MatProgressSpinnerModule, FindByIdPipe, ZoomWrapper, TopMenuComponent, CdkDropListGroup ]
})

export class ProgramPageComponent extends Wrapper<ProgramPageComponent>  { // implements OnInit, OnDestroy
    animationTiming = "300ms"
    window = window;
    programs_index = 0;
    programsLoaded: boolean = false
    manageSessionStates = manageSessionStates
    programNewDay: NewDay
    page_name = PAGE_NAME.program_builder;
    public is_logistics = true;
    readonly _file: string = 'program.page.ts';
    is_loaded = true;
    newTitle = '';
    page = '';
    addInputView = false;
    loop_resizing = true;
    event: JoiEvent
    sponsors: { [id:string]: Sponsor }
    programTimezoneIds: Set<string> = new Set()
    outdatedvenueformatvenues
    dragging = false;
    draggedProgramId: string
    draggedDay: number
    mobileProgramId: string
    programOptions: DropdownOption[]

    programExpandToggleData: TextToggleData = {
      left: "CONDENSED",
      right: "EXPANDED",
      leftSelected: false,
      toggleNotifier: this.toggleProgramDetailView.bind(this),
      loaded: false
    }
    list = [["1","2","3","4","5"],["a","b","c","d","e"]];

    labelMaps: LabelMaps = makeEmptyLabelMaps()
    // saveDragulaOrderTimeout
    // saveDragulaOrderDelay = 500
    // dragulaInitialized = false
    // @ViewChild('lottieloader') lottieloader:ElementRef;
    @ViewChildren('dummyInput') dummyInput;
    @HostListener('mousedown', ['$event']) onMouseDown($event) {
      if ($event.target.nodeName !== 'INPUT' && 
        $event.target.nodeName !== 'TEXTAREA' && 
        !$event.target.closest('.ql-toolbar') // for quill
      ) {
        this.dummyInput.first.nativeElement.focus();
      }
    }
    visiblePrograms: Set<string> = new Set()
    programsList: Program[] = []
    hiddenLoaded: boolean
    MAX_DEFAULT_PROGRAMS = 5
    editingVisiblePrograms = false
    showBarChart = false
    canDrag = true

    debugProgram(program: Program) {
      const programData = getPropSizes(program)
      console.log(programData)
      this.showBarChart = true
      createBarChart(programData, '#programChart', "Program Prop Percentages")      
    }

    toggleDrag() {
      this.canDrag = !this.canDrag
      saveLocal('dragSessions', this.canDrag)
    }
    trackByProgram = trackByProgram

    async editVisiblePrograms() {
      this.changeDetectorRef.detach()
      const checkboxes = this.programsList.map(p => ({
        title: p.title,
        checked: this.visiblePrograms.has(p.id),
        id: p.id
      }))
      const originalOrderString = JSON.stringify(checkboxes.map(c => c.id))
      const data: OnlyChecksDialogData = {
        title: 'Visible Room Locations and Order',
        checkboxes,
        instructions: 'Check to show a given room/location.  Drag to change the order.',
        drag: true,
        atLeastOne: true,
        backgroundColor: '#FFD157'
      }
      await openDialogGetResult(this.dialog, CheckDialogComponent, { width: '360px', disableClose: true, data })
      this.visiblePrograms = new Set(data.checkboxes.filter(c => c.checked).map(c => c.id))
      saveLocal(`${this.eventService.eventId}/visiblePrograms`, Array.from(this.visiblePrograms))
      this.changeDetectorRef.reattach()
      const newOrder = data.checkboxes.map(c => c.id)
      if (originalOrderString !== JSON.stringify(newOrder)) {
        this.editingVisiblePrograms = true
        this.programService.updateProgramOrder(newOrder)
      }
      if (this.visiblePrograms.size <= this.programs_index || 0) this.programs_index = 0
    }
    readState: keyof ManageSessionStates
    
    constructor(
        private element: ElementRef,
        private changeDetectorRef: ChangeDetectorRef,
        public programService: ProgramService,
        public permissionsService: EventPermissionsService,
        ) 
    {
      super()

      this.canDrag = loadLocal<boolean>('dragSessions', true)

        this.subCallback(this.store.select(eventsFeature.selectEvent), event => {
          this.event = event
          if (event && !this.programExpandToggleData.loaded) {
            this.programExpandToggleData.leftSelected = loadLocal(`${event.eventId}/programsCondensed`, true) // apparently we want to start on wide view (event opens in program / wide view from Rob).  NOPE, back to collapsed view per Rob
            setTimeout(() => {
              this.programExpandToggleData.loaded = true
            }, 100)
          }
        })

         this.selectProp(programOptionsReselector, true, 'programOptions')
        this.selectCallback<Program[], any>(programsArray, null, programs => {
          this.programsList = jsonCopyObject(programs)
          this.editingVisiblePrograms = false
          if (this.hiddenLoaded) return
          if (programs.length) {
            if (!this.mobileProgramId) this.mobileProgramId = programs[0].id

            this.hiddenLoaded = true
            let previouslyVisiblePrograms = loadLocal(`${this.eventService.eventId}/visiblePrograms`)
            if (previouslyVisiblePrograms && this.event.programOrder) previouslyVisiblePrograms = previouslyVisiblePrograms.filter(pId => this.event.programOrder.includes(pId))
            this.visiblePrograms = previouslyVisiblePrograms ? new Set(previouslyVisiblePrograms) : new Set(programs.slice(0,this.MAX_DEFAULT_PROGRAMS).map(p => p.id)) 
          }
        })
        this.subProp(this.store.select(sponsorsFeature.selectEntities), 'sponsors')
        this.subProp(this.store.select(eventsFeature.selectLabelMaps), 'labelMaps')
        this.subProp(this.store.select(getProgramTimezoneIds), 'programTimezoneIds')

        // this catches when the event venues object is added to the db and it deletes the current stored outdated venues
        this.subCallback(this.store.select(missingOutdatedVenueFormatVenues), venuesToAdd => {
          if(venuesToAdd.length) this.store.dispatch(eventsActions.updateEventVenues(venuesToAdd))
        })
        
        this.subCallback(this.store.select(permissionsFeature.selectAccess), access => {
          const types = access.types || []
          this.is_logistics = (types.includes('logistics') && !types.includes('program'))
        })

        this.subProp(this.store.select(manageSessionPermissionReselector), 'readState')
        

        this.subCallback(this.store.select('programs','new_day_added'), async(newDay) => {
          this.programNewDay = newDay
          if(!newDay || newDay.program_idx === undefined || !newDay.program_displaying) return;
          await sleepForMS(1)
          this.focusOnStartTime(newDay.program_idx)
        })

         setTimeout(_ => this.loop_resizing = false, 4000)
         this.uiService.changePageTitle("Build View", true);
    }

    addVisible(programId: string) {
      this.visiblePrograms.add(programId)
      this.visiblePrograms = new Set(this.visiblePrograms)
    }

    removeVisible(programId: string) {
      this.visiblePrograms.delete(programId)
      this.visiblePrograms = new Set(this.visiblePrograms) // needed to trigger template update
    }

    changeDayStart(day, lane, timeText) {
      day.start = timeText
      this.programService.upsertProgram(lane)
    }

    toggleProgramDetailView() {
      this.programExpandToggleData.leftSelected = !this.programExpandToggleData.leftSelected
      saveLocal(`${this.event.eventId}/programsCondensed`, this.programExpandToggleData.leftSelected)
    }

    // initializeDragula() {
    //   if (this.dragulaInitialized) {
    //     this.dragula.dropModel('lanes-bag')
    //     this.dragula.dropModel('cards-bag')
    //   }
    //   this.dragulaInitialized = true
    //   const self = this;
    //   const lane_drake = this.dragula.createGroup('lanes-bag', {
    //       direction: 'horizontal',
    //       moves: function (el, target, source, sibling) {
    //           // console.log({ el, target, source, sibling })
    //           if ((self.event && self.event.is_readonly) || self.is_logistics || self.permissionsService.readonly[self.page_name] || window.innerWidth <= 768) return false;
    //           return source.classList.contains('floating_hover_area');
    //       }, 
    //       accepts: function (el, target, source, sibling) {
    //         // console.log(sibling.classList, { el })
    //         return true
    //       }, 
    //   })

    //   const card_drake = this.dragula.createGroup('cards-bag', {
    //     mirrorContainer: this.element.nativeElement.closest('program-page'),
    //     moves: (el, target, source, sibling) => {
    //       if (
    //         (self.event && self.event.is_readonly) ||
    //         self.is_logistics ||
    //         self.permissionsService.readonly[self.page_name] ||
    //         window.innerWidth <= 768
    //       ) return false
      
    //       return self.canDrag && source.parentElement.classList.contains('sess_handle')
    //     }
    //   })
    //   this.subCallback(this.dragula.dropModel(), args => this.updateProgramsOrSessionsOrder(args))
    //   this.subCallback(this.dragula.drag(), async(val) => {
    //     const [ programId, dayString ] = val.source.id.split("-")
    //     const day = parseInt(dayString)
    //     // console.log({ programId, day })
    //     this.draggedProgramId = programId
    //     this.draggedDay = day
    //     this.dragging = true;
    //     await sleepForMS(1)
    //     const el = document.getElementsByClassName('gu-mirror');
    //     if (el && el[0]) {
    //       const elStyle = el[0]['style']
    //       elStyle.transform = 'scale(' + this.uiService.zoom_mulitplier + ')';
    //       elStyle.transformOrigin = '0% 0%';
    //       elStyle.width = !this.programExpandToggleData.leftSelected ? '800px' : '300px';
    //     }
    //   }, this.$destroy)
    //   this.subCallback(this.dragula.drop(), () => null)
    //   this.subCallback(this.dragula.dragend(), () => this.dragging = false)

    //   setTimeout(() => {
    //       card_drake.drake.on('out', (el, source) => {
    //           const container = source.closest('.lane_scroller_container')
    //           const bound = container.getBoundingClientRect();
    //           document.onmousemove = e => {
    //               const event = e || this.window.event;
    //               const mouseY = event['pageY']
    //               if (mouseY < bound.top) {
    //                   container.scrollBy(0, -15);
    //               } else if (mouseY > (bound.bottom) - 60) {
    //                   container.scrollBy(0, 15);
    //               }

    //           }
    //       })
    //       // detach the mouse move event when the drag ends
    //       card_drake.drake.on('dragend', el => document.onmousemove = null);
    //       card_drake.drake.on('over', el => document.onmousemove = null);
    //       lane_drake.drake.on('dragend', el => document.onmousemove = null);
    //       lane_drake.drake.on('over', el => document.onmousemove = null);
    //   })
    // }

    ngOnInit() {
      const self = this;
      this.subCallback(this.store.select('programs','loaded'), loaded => {
        this.programsLoaded = loaded
        if (!loaded) return
        setTimeout(()=>{
          this.changeDetectorRef.detectChanges()
          const programs = document.querySelector('.programs')
          if (programs) self.addSwipedEventsListeners(programs)
        }, 0)
      })
    }


    // addHammerOn(programs){
    //     const hammer = new Hammer(programs);
    addSwipedEventsListeners(programs){
        const that = this;
        document.addEventListener('swiped-left', function () {
            if (window.innerWidth <= 768) {
                if (that.programService.programs.length > that.programs_index) {
                    that.programs_index++;
                }
            }
        });
        document.addEventListener('swiped-right', function () {
            if (window.innerWidth <= 768) {
                if (that.programs_index > 0) {
                    that.programs_index--;
                }
            }
        });
    }

    // ngOnDestroy() {
    //   this.dragula.destroy('lanes-bag')
    //   this.dragula.destroy('cards-bag')
    // }

    async addProgram() {
        // if (this.event.CURRENT_EVENT.closed) return; // todo: handle closed
        this.changeDetectorRef.detach()
        const result = await openDialogGetResult<InputDialogReturnData>(this.dialog, NewProgramDialogComponent, { width: '480px', disableClose: true })
        console.log({ result })
        if (result === null) {
          this.changeDetectorRef.reattach()
          return
        }
        const name = result.values[0]
        const programStart: Partial<Program> = { title: name }
        const inherit_from = result.values[1] ? this.programService.programs.find(p=>p.id===result.values[1]) : null ;
        console.log({ inherit_from});
        const inherit = !!inherit_from ? copyObjectWithProps(inheritableFields, inherit_from) : {}
        this.is_loaded = false;
        console.log({ inherit: jsonCopyObject(inherit) });
        this.store.dispatch(programsActions.programSessionDayAdded({program_idx:-1})) // <== what does this even do? 
        
        console.log({ programsBeforeAddProgram: jsonCopyObject(this.programService.programs) })
        const id = await this.programService.addProgram(Object.assign(inherit, programStart), result.importedSessions)
        this.visiblePrograms.add(id) // saved in programService.addProgram
        this.eventService.setProgramName(id, name)
        this.mobileProgramId = id
        this.is_loaded = true
        this.changeDetectorRef.reattach()
        // console.log({ id }) 

        if (result.type === 'AlternativeButton') {
          this.editProgram(id, !name)
        }
    }


    // updateProgramsOrSessionsOrder(args) {
    //   const programsCopy: Program[] = jsonCopyObject(this.programService.programs)
    //   // console.log({ programs:this.programService.programs});
    //   const { source, target, sourceIndex, targetIndex, sourceModel, targetModel, name, item: droppedProgram } = args
    //   // console.log({ args, programServicePrograms: jsonCopyObject(this.programService.programs) })

    //   const visibleModel = targetModel.filter(p => this.visiblePrograms.has(p.id))
    //   const visibleIndex = visibleModel.find(p => p.id === droppedProgram.id)

    //   if (name === 'lanes-bag') {
    //     let nextProgram = visibleModel[visibleIndex + 1]
    //     if (!nextProgram) nextProgram = targetModel[targetIndex + 1]

    //     let previousProgram = visibleModel[visibleIndex - 1]
    //     if (!previousProgram) previousProgram = targetModel[targetIndex - 1]


    //     let programs: Program[]
    //     console.log({ droppedProgram: droppedProgram.title, nextProgram: nextProgram?.title, previousProgram: previousProgram?.title, sourceIndex, targetIndex, programServicePrograms: jsonCopyObject(this.programService.programs), targetModel: jsonCopyObject(targetModel), sourceModel: jsonCopyObject(sourceModel) })
    //     if (!nextProgram) {
    //       if (!previousProgram) {
    //         programs = this.programService.programs.filter(p => p.id !== droppedProgram.id)
    //         programs.push(droppedProgram)
    //       } else {
    //         programs = []
    //         this.programService.programs.forEach(p => {
    //           if (p.id === droppedProgram.id) return
    //           programs.push(p)
    //           if (p.id === previousProgram.id) programs.push(droppedProgram)
    //         })
    //       }
    //     } else {
    //       programs = []
    //       this.programService.programs.forEach(p => {
    //         if (p.id === droppedProgram.id) return
    //         if (p.id === nextProgram.id) programs.push(droppedProgram)
    //         programs.push(p)
    //       })
    //     }
    //     // programs.map(p => p.title).forEach(console.log)
    //     // console.log(programs)
    //     this.programsList = [...programs]
    //     this.programService.updateProgramOrder(programs.map(p => p.id));
    //     return;
    //   }
    //   // duplicated ids have - in them so this had to be re-written
    //   const sourceProgramId = source.id.split(/-\d*$/)[0];
    //   const targetProgramId = target.id.split(/-\d*$/)[0];
    //   const sourceDay = source.id.split("-").pop();
    //   const targetDay = target.id.split("-").pop();
    //   // console.log({ sourceProgramId, targetProgramId, source, target, sourceIndex, targetIndex, sourceModel, targetModel })
    //   const sourceProgram = programsCopy.find(p => p.id === sourceProgramId)
    //   // console.log({ sourceProgram, sourceDay});
    //   const sourceSessionGroupIds = sourceProgram.sessions[+sourceDay - 1].sessions

    //   if (sourceProgramId === targetProgramId && sourceDay === targetDay) {
    //     const sessionId = sourceSessionGroupIds.splice(sourceIndex, 1)[0]
    //     sourceSessionGroupIds.splice(targetIndex, 0, sessionId)
    //     this.programService.upsertProgram(sourceProgram, {file:this._file, function:'programsUpdated', data:args, message:'There was an error moving this sesssion.'});
    //   } else {
    //     const targetProgram = programsCopy.find(p => p.id === targetProgramId) // could be same as sourceProgram, that's ok

    //     const targetProgramGroupIds = targetProgram.sessions[+targetDay-1].sessions

    //     const sessionId = sourceSessionGroupIds.splice(sourceIndex, 1)[0]
    //     targetProgramGroupIds.splice(targetIndex, 0, sessionId)

    //     const session = sourceProgram.sessions_obj[sessionId]
    //     delete sourceProgram.sessions_obj[sessionId]
    //     targetProgram.sessions_obj[sessionId] = session


    //     this.programService.batchUpdateProgram([sourceProgram, targetProgram])
    //     // console.log({ sourceProgram: jsonCopyObject(sourceProgram), targetProgram: jsonCopyObject(targetProgram ), programsServicePrograms: jsonCopyObject(programsCopy) })

    //   }
    //   // this.initializeDragula()
    //   // setTimeout(() => console.log("after delay", {programsServicePrograms: jsonCopyObject(programsCopy) }),1000)
    // }

    public async editProgram(programId: string, focusTitle = false) {
        console.log({ programId, focusTitle })
        // const wf = createSelector(workforceStateSelector, (state) => state.workforce);
        // const workers = await lastValueFrom(this.store.select(wf).pipe(take(1)))
        console.log('test')
        if (!programId) return;
        const data: ManageProgramData = { programId, focusTitle }
        this.changeDetectorRef.detach()
        // make sure autoFocus is false below, otherwise the title cannot be focused
        await openDialogGetResult(this.dialog, ManageProgramComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
        this.changeDetectorRef.reattach()
    }

    public async editSession(session: Session) {
      const data: ManageSessionData = { sessionId: session.id }
      this.changeDetectorRef.detach()
      await openDialogGetResult(this.dialog, ManageSessionComponent, { autoFocus: !this.is_logistics, disableClose: true, data, panelClass: 'full-screen-modal' })
      this.changeDetectorRef.reattach()
    }

    public focusOnStartTime(idx: number) {
        if (idx === -1) idx = this.programService.programs.length - 1;
        const program = this.element.nativeElement.getElementsByClassName('lane')[idx];
        if (program) {
            const start_times = program.getElementsByClassName('program_start')
            const start_time = start_times[start_times.length - 1].getElementsByTagName('INPUT');
            start_time[0].focus();
        }
        this.store.dispatch(programsActions.programSessionDayAdded({program_idx:undefined, program_displaying:false})) // reset new_day
    }


    // trackByProgram(index, program: Program) {
    //   return program.id
    // }

}
